
import { applicationService } from '@/services/application.service'

const state = {
    dialog: false,
    loading: false,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    applist: [],
    maintenance_switch:false,
    application:{}
};
const actions = {
    OpenDialogForm({commit }) {
        commit('opendialog');
    },
    closeDialog({commit }) {
        commit('closedialog');
    },
    getApplist({commit }) {
        commit('setloading');
        applicationService.Applist().then(data => {
            //console.log(data.data[0]);
            commit('addResponseApp', data);
        }, error => {
            console.log(error);
        });
    },
    setmaxOTP({ dispatch }, status) {
        applicationService.setMaxOTP(status)
            .then(() => {
                dispatch('alert/success', 'Update OTP OK!', { root: true });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    maintenance({ dispatch,commit }, status) {
        applicationService.setMaintenance(status)
            .then(() => {
                dispatch('alert/success', 'update OK', { root: true });
                commit('setMaintenance',status !== 0);
            }, error => {
                dispatch('alert/error', error, { root: true });
                commit('setMaintenance',status === 0);
            })
        // UtilsService.setMaintenance(status)
        //     .then(() => {
        //         dispatch('alert/success', 'update OK', { root: true });
        //         commit('setMaintenance',status !== 0);
        //     }, error => {
        //         dispatch('alert/error', error, { root: true });
        //         commit('setMaintenance',status === 0);
        //     })
    },
    kirimnotif({ dispatch }, pdata) {
        applicationService.sendpush(pdata)
            .then(() => {
                dispatch('alert/success', 'pesan terkirim', { root: true });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    AddNewApp({ dispatch, commit }, newData) {
        commit('setloading');
        applicationService.AddApp(newData)
            .then(() => {
                dispatch('alert/success', 'Save Successfully', { root: true });
                //commit('ShowAdd', data);
                applicationService.Applist().then(data => {
                    commit('addResponseApp', data);
                }, error => {
                    console.log(error);
                });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    },
    EditApp({ dispatch, commit }, editdata) {
        applicationService.EditApp(editdata)
            .then(() => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                applicationService.Applist().then(data => {
                    commit('addResponseApp', data);
                }, error => {
                    console.log(error);
                });
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    }
}
const mutations = {
    setMaintenance(state,status) {
        console.log("OKE:"+status);
        state.maintenance_switch = status;
    },
    setloading(state) {
        state.loading = true
    },
    ShowAdd(state, st) {
        console.log(st);
        state.dialog = false;
    },
    addResponseApp(state, apps) {
        state.applist = []
        state.applist = apps.data;
        state.application=apps.data;
        state.maintenance_switch=apps.data.maintenance === 1;
        state.dialog = false;
        state.loading = false;

        //console.log(state.applist[0]);
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}

export const applikasi = {
    namespaced: true,
    state,
    actions,
    mutations
};
